import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'
import type { DateString } from '../../../shared/lib/typeHelpers.no-deps'
import type { ScheduledInstanceSync } from '../../../shared/domain/scheduledInstance/types.no-deps'

export const route: Route = { method: 'POST', pattern: '/api/schedules/syncTodo' }

type Params = never

type Body = {
    teams: number[]
    lastSyncTime: DateString
    sendWorkflowActions?: true
}

type Query = never

type Output = {
    syncTime: Date
    teams: number[]
    scheduledInstances: ScheduledInstanceSync[]
}

export type SyncTodoEndpoint = Endpoint<Params, Body, Query, Output>

export const syncTodoRequest = (request: Request, args: RequestArgs<SyncTodoEndpoint>) =>
    request<SyncTodoEndpoint>(route, args)
